module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.area && _vm.area.idArea) ? _c('span', [_vm._v("Editar Area")]) : _c('span', [_vm._v("Crear area")])]), _c('span', {
    staticClass: "icon close pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Area")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombre),
      expression: "nombre"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombre = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Gerencia")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreGerencia),
      expression: "nombreGerencia"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving,
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.nombreGerencia)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaGerencia = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreGerencia = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaGerencia = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.borrarGerencia
    }
  }, [_vm._m(0)])]), _c('p'), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaGerencia) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('gerencia', {
    on: {
      "selected": _vm.seleccionarGerencia,
      "close": function($event) {
        _vm.mostrarBusquedaGerencia = false
      }
    }
  })], 1) : _vm._e()])], 1)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66fcebf1","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Gestion_Areas_Editar.vue
// module id = 893
// module chunks = 0